import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function leadCountReducer(state = initialState.leadCountData, action) {
  switch (action.type) {
    case types.LOAD_LEADCOUNT_DATA_SUCCESS:
      return action.leadCountData;
    default:
      return state;
  }
}
